module.exports = __webpack_public_path__ + "img/background.6eff8fc7.png";